export class ProgressHelper {
  /**
   * 
   * @deprecated: Old method use decideProgressColor as per new design
   */
  progressColor(percent: number = 0) {
    if (percent < 25 || percent > 100)
      return 'red';
    else if (percent >= 75)
      return 'green';
    else if (percent >= 50)
      return 'blue';
    else
      return 'orange';
  }

  decideProgressColor(percent: number = 0) {
    if (percent >= 100)
      return 'green';
    else
      return 'blue';
  }

  receivedPercentage(quantityOrdered: number = 0, quantityReceived: number = 0,
    showExact: boolean = false, rounded: boolean = true) {
    var result = (quantityReceived / quantityOrdered) * 100;
    if (rounded)
      result = Math.round(result);
    return (isNaN(result) || !isFinite(result)) ? 0 : result > 100 ? (showExact ? result : 100) : result;
  }
}